export function setupHubspot(hubspotId: string) {
    function load() {
        const script = document.createElement("script");
        script.src = `https://js.hs-scripts.com/${hubspotId}.js`;
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        script.id = "hs-script-loader";

        const firstScript = document.getElementsByTagName("script")[0];
        firstScript.parentNode?.insertBefore(script, firstScript);
    }

    if (document.readyState === "complete") {
        load();
    } else {
        window.addEventListener("load", load, false);
    }
}
